/* Flash product page (new design): trip length + plan picker, order card, sticky bar, pop-ups.
   Reads its data from the <script data-fgs-json> block inside each [data-fgs-pdp] section. */
(function () {
  'use strict';

  /* ---------- Language: Indonesian when the store language is "id" (set by the sections as data-fgs-lang) ---------- */
  var ID = {
    'Light': 'Ringan', 'Moderate': 'Sedang', 'Heavy': 'Berat',
    '1 GB/day': '1 GB/hari', '2 GB/day': '2 GB/hari', '3 GB/day': '3 GB/hari',
    'Mostly chat, maps & email. Occasional social media.': 'Kebanyakan chat, peta & email. Sesekali media sosial.',
    'Chat, maps, social media & photo uploads all day.': 'Chat, peta, media sosial & unggah foto sepanjang hari.',
    'Heavy scrolling, video calls & uploads.': 'Banyak scroll, video call & unggah.',
    'POPULAR': 'POPULER', 'See Fewer Plans': 'Lihat Lebih Sedikit', 'See More Plans': 'Lihat Paket Lainnya',
    'No plans are available for this trip length. Please pick another one.': 'Tidak ada paket untuk durasi ini. Silakan pilih durasi lain.',
    'Added to cart.': 'Ditambahkan ke keranjang.',
    'This plan could not be added to the cart. Please try again.': 'Paket ini gagal ditambahkan ke keranjang. Silakan coba lagi.',
    'Supports eSIM': 'Mendukung eSIM', 'No eSIM support': 'Tidak mendukung eSIM',
    'SIM Card': 'Kartu SIM', 'SIM Cards': 'Kartu SIM', 'eSIMs': 'eSIM', 'Save': 'Hemat', 'e.g.': 'mis.',
    'No countries match': 'Tidak ada negara yang cocok dengan'
  };
  var COUNTRY_ID = {
    'afghanistan': 'Afganistan', 'albania': 'Albania', 'algeria': 'Aljazair', 'argentina': 'Argentina', 'armenia': 'Armenia',
    'australia': 'Australia', 'austria': 'Austria', 'azerbaijan': 'Azerbaijan', 'bahrain': 'Bahrain', 'bangladesh': 'Bangladesh',
    'belarus': 'Belarus', 'belgium': 'Belgia', 'bosnia and herzegovina': 'Bosnia dan Herzegovina', 'brazil': 'Brasil', 'brunei': 'Brunei',
    'bulgaria': 'Bulgaria', 'cambodia': 'Kamboja', 'canada': 'Kanada', 'chile': 'Chili', 'china': 'China', 'colombia': 'Kolombia',
    'croatia': 'Kroasia', 'cyprus': 'Siprus', 'czechia': 'Ceko', 'czech republic': 'Ceko', 'denmark': 'Denmark', 'egypt': 'Mesir',
    'estonia': 'Estonia', 'finland': 'Finlandia', 'france': 'Prancis', 'georgia': 'Georgia', 'germany': 'Jerman', 'greece': 'Yunani',
    'hong kong': 'Hong Kong', 'hungary': 'Hongaria', 'iceland': 'Islandia', 'india': 'India', 'indonesia': 'Indonesia', 'iran': 'Iran',
    'iraq': 'Irak', 'ireland': 'Irlandia', 'israel': 'Israel', 'italy': 'Italia', 'japan': 'Jepang', 'jordan': 'Yordania',
    'kazakhstan': 'Kazakhstan', 'kenya': 'Kenya', 'kuwait': 'Kuwait', 'kyrgyzstan': 'Kirgizstan', 'laos': 'Laos', 'latvia': 'Latvia',
    'lebanon': 'Lebanon', 'liechtenstein': 'Liechtenstein', 'lithuania': 'Lituania', 'luxembourg': 'Luksemburg', 'macau': 'Makau',
    'macao': 'Makau', 'malaysia': 'Malaysia', 'maldives': 'Maladewa', 'malta': 'Malta', 'mexico': 'Meksiko', 'moldova': 'Moldova',
    'monaco': 'Monako', 'mongolia': 'Mongolia', 'montenegro': 'Montenegro', 'morocco': 'Maroko', 'myanmar': 'Myanmar', 'nepal': 'Nepal',
    'netherlands': 'Belanda', 'new zealand': 'Selandia Baru', 'north macedonia': 'Makedonia Utara', 'norway': 'Norwegia', 'oman': 'Oman',
    'pakistan': 'Pakistan', 'peru': 'Peru', 'philippines': 'Filipina', 'poland': 'Polandia', 'portugal': 'Portugal', 'qatar': 'Qatar',
    'romania': 'Rumania', 'russia': 'Rusia', 'san marino': 'San Marino', 'saudi arabia': 'Arab Saudi', 'serbia': 'Serbia',
    'singapore': 'Singapura', 'slovakia': 'Slowakia', 'slovenia': 'Slovenia', 'south africa': 'Afrika Selatan', 'south korea': 'Korea Selatan',
    'korea': 'Korea Selatan', 'spain': 'Spanyol', 'sri lanka': 'Sri Lanka', 'sweden': 'Swedia', 'switzerland': 'Swiss', 'taiwan': 'Taiwan',
    'tajikistan': 'Tajikistan', 'tanzania': 'Tanzania', 'thailand': 'Thailand', 'tunisia': 'Tunisia', 'turkey': 'Turki', 'turkiye': 'Turki',
    'turkmenistan': 'Turkmenistan', 'ukraine': 'Ukraina', 'united arab emirates': 'Uni Emirat Arab', 'united kingdom': 'Inggris',
    'united states': 'Amerika Serikat', 'usa': 'Amerika Serikat', 'uzbekistan': 'Uzbekistan', 'vatican city': 'Vatikan', 'vietnam': 'Vietnam', 'viet nam': 'Vietnam'
  };
  var LANG = null;
  function lang() {
    if (LANG) return LANG;
    var el = document.querySelector('[data-fgs-lang]');
    LANG = el ? el.getAttribute('data-fgs-lang') : (/^id/i.test(document.documentElement.lang || '') ? 'id' : 'en');
    return LANG;
  }
  function L(en) { return lang() === 'id' && ID[en] != null ? ID[en] : en; }
  function countryLabel(name) {
    // "China- Tibet Autonomous Region" -> "Tibet, China" (the flag still comes from the full name)
    var m = String(name).match(/^(.+?)\s*-\s*(.+?)\s+autonomous region$/i);
    if (m) {
      var parent = lang() === 'id' ? (COUNTRY_ID[norm(m[1])] || m[1]) : m[1];
      return m[2] + ', ' + parent;
    }
    return lang() === 'id' ? (COUNTRY_ID[norm(name)] || name) : name;
  }

  var GUIDE = [null,
    { name: 'Light', amt: '1 GB/day', desc: 'Mostly chat, maps & email. Occasional social media.' },
    { name: 'Moderate', amt: '2 GB/day', desc: 'Chat, maps, social media & photo uploads all day.' },
    { name: 'Heavy', amt: '3 GB/day', desc: 'Heavy scrolling, video calls & uploads.' }];

  var ALIASES = {
    'turkiye': ['turkey'], 'turkey': ['turkiye'], 'czechia': ['czech republic'], 'czech republic': ['czechia'],
    'united kingdom': ['uk', 'britain', 'great britain', 'england', 'scotland', 'wales', 'northern ireland'],
    'netherlands': ['holland'], 'germany': ['deutschland'], 'switzerland': ['swiss', 'schweiz', 'suisse'],
    'austria': ['osterreich'], 'spain': ['espana'], 'greece': ['hellas'], 'croatia': ['hrvatska'],
    'poland': ['polska'], 'italy': ['italia'], 'united states': ['usa', 'us', 'america'],
    'south korea': ['korea'], 'united arab emirates': ['uae', 'dubai']
  };

  function norm(t) { return String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim(); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function init(root) {
    if (root.__fgs) return;
    root.__fgs = true;
    var json = $(root, '[data-fgs-json]');
    if (!json) return;
    var D;
    try { D = JSON.parse(json.textContent); } catch (e) { return; }

    var currency = String(D.currency || 'IDR').toUpperCase();
    function money(cents) {
      var amount = Math.round(Number(cents || 0)) / 100;
      if (currency === 'IDR') return 'Rp' + String(Math.round(amount)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      // International store: symbol + 2 decimals, e.g. $10.19, S$13.90, €9.49. A plain "$" is only ever US dollars.
      var SYM = { USD: '$', SGD: 'S$', HKD: 'HK$', AUD: 'A$', NZD: 'NZ$', TWD: 'NT$', CAD: 'C$', EUR: '€', GBP: '£', MYR: 'RM', JPY: '¥' };
      if (SYM[currency]) return SYM[currency] + amount.toFixed(currency === 'JPY' ? 0 : 2).replace(/\B(?=(\d{3})+(?!\d)(?=\.|$))/g, ',');
      if (window.FGSStorefrontMoney) return window.FGSStorefrontMoney.format(cents, currency);
      return amount.toFixed(2) + ' ' + currency;
    }
    function perDay(cents, days) {
      var c = cents / days;
      var unit = lang() === 'id' ? ' / hari' : ' / day';
      if (currency === 'IDR') return 'Rp' + Math.round(c / 100 / 1000) + 'k' + unit;
      return money(c) + unit;
    }

    /* ---------- Variants -> plans ---------- */
    function kindOf(v) {
      var o = String(v.option1 || '');
      if (/daily/i.test(o)) return 'daily';
      if (/fixed|total/i.test(o)) return 'total';
      return null;
    }
    function daysOf(v) { var m = String(v.option3 || '').match(/\d+/); return m ? parseInt(m[0], 10) : 0; }
    function quotaInfo(q) {
      q = String(q || '');
      if (/unlim/i.test(q)) return { unlimited: true, sort: 1e9, amount: 'Unlimited' };
      var m = q.match(/[\d.,]+/);
      var n = m ? parseFloat(m[0].replace(',', '.')) : 0;
      var mb = /mb/i.test(q) && !/gb/i.test(q);
      return { unlimited: false, sort: mb ? n / 1000 : n, amount: n + (mb ? ' MB' : ' GB') };
    }

    var variants = (D.variants || []).filter(function (v) { return v && v.id; });
    var structured = variants.some(kindOf);
    var plans = [];
    var byKey = {};
    variants.forEach(function (v) {
      var kind = structured ? kindOf(v) : 'single';
      if (!kind) return;
      var key = structured ? kind + '|' + v.option2 : 'v|' + v.id;
      if (!byKey[key]) {
        var qi = structured ? quotaInfo(v.option2) : { unlimited: false, sort: 0, amount: v.title };
        var label = !structured ? (v.title === 'Default Title' ? (D.title || v.title) : v.title) : qi.unlimited ? 'Unlimited' : kind === 'daily' ? qi.amount + (lang() === 'id' ? '/hari' : '/day') : qi.amount + ' total';
        byKey[key] = { key: key, kind: kind, option2: v.option2, label: label, short: label.replace(' total', ''), sort: qi.sort, unlimited: qi.unlimited, variants: [] };
        plans.push(byKey[key]);
      }
      byKey[key].variants.push(v);
    });
    plans.sort(function (a, b) {
      if (a.kind !== b.kind) return a.kind === 'daily' ? -1 : 1;
      return a.sort - b.sort;
    });
    var daily = plans.filter(function (p) { return p.kind === 'daily'; });
    var total = plans.filter(function (p) { return p.kind === 'total'; });
    var both = daily.length > 0 && total.length > 0;

    // Trip lengths: from daily plans, or from fixed plans' validity when a product has no daily plans.
    var dayPool = daily.length ? daily : total;
    var dayList = [];
    dayPool.forEach(function (p) { p.variants.forEach(function (v) { var d = daysOf(v); if (d && dayList.indexOf(d) < 0) dayList.push(d); }); });
    dayList.sort(function (a, b) { return a - b; });

    function variantFor(plan, days) {
      if (!structured) return plan.variants[0];
      var list = plan.variants.filter(function (v) { return v.available !== false; });
      if (plan.kind === 'daily') {
        return list.filter(function (v) { return daysOf(v) === days; })[0] || null;
      }
      // Fixed plans: the shortest validity that covers the trip.
      var fits = list.filter(function (v) { return !days || daysOf(v) >= days; }).sort(function (a, b) { return daysOf(a) - daysOf(b); });
      return fits[0] || null;
    }

    var squash = function (t) { return norm(t).replace(/\s+/g, ''); };
    function recommended() {
      var rd = squash(D.recommendedDaily), rf = squash(D.recommendedFixed);
      return daily.filter(function (p) { return rd && squash(p.option2) === rd; })[0] ||
        total.filter(function (p) { return rf && squash(p.option2) === rf; })[0] || null;
    }
    var popular = recommended();

    // Which plans show before "See More Plans".
    var firstKeys;
    if (both) {
      var d3 = daily.filter(function (p) { return !p.unlimited; }).slice(0, 3);
      var t3 = total.length > 3 ? total.slice(1, 4) : total.slice(0, 3);
      firstKeys = d3.concat(t3).map(function (p) { return p.key; });
    } else {
      firstKeys = plans.slice(0, 6).map(function (p) { return p.key; });
    }

    /* ---------- State ---------- */
    var state = { days: 0, key: '', qty: 1, more: false };
    var initial = variants.filter(function (v) { return v.id === D.initialVariantId; })[0];
    var urlVariant = (location.search.match(/[?&]variant=(\d+)/) || [])[1];
    if (urlVariant) initial = variants.filter(function (v) { return String(v.id) === urlVariant; })[0] || initial;

    var wanted = parseInt(D.defaultDays, 10) || 7;
    // ?days=7 in the link (e.g. from the homepage trip form) preselects that trip length, or the next longer one
    var urlDays = (location.search.match(/[?&]days=(\d+)/) || [])[1];
    if (urlDays) wanted = parseInt(urlDays, 10) || wanted;
    state.days = dayList.indexOf(wanted) >= 0 ? wanted : (dayList.filter(function (d) { return d >= wanted; })[0] || dayList[0] || 0);
    var start = popular || daily.filter(function (p) { return !p.unlimited; })[0] || plans[0];
    if (urlVariant && initial) {
      var ip = plans.filter(function (p) { return p.variants.indexOf(initial) >= 0; })[0];
      if (ip) { start = ip; if (ip.kind === 'daily' && dayList.indexOf(daysOf(initial)) >= 0) state.days = daysOf(initial); }
    }
    state.key = start ? start.key : '';

    /* ---------- Rendering ---------- */
    var els = {
      days: $(root, '[data-fgs-days]'), daysHeading: $(root, '[data-fgs-days-heading]'),
      plans: $(root, '[data-fgs-plans]'), more: $(root, '[data-fgs-more]'), moreToggle: $(root, '[data-fgs-more-toggle]'),
      moreLabel: $(root, '[data-fgs-more-label]'), diff: $(root, '[data-fgs-diff]'),
      detail: $(root, '[data-fgs-detail]'), qtyN: $(root, '[data-fgs-qty-n]'), save: $(root, '[data-fgs-save]'),
      saveAmt: $(root, '[data-fgs-save-amt]'), was: $(root, '[data-fgs-was]'), total: $(root, '[data-fgs-total]'),
      bar: $(root, '[data-fgs-bar]'), barPrice: $(root, '[data-fgs-bar-price]'), barPlan: $(root, '[data-fgs-bar-plan]'),
      barDays: $(root, '[data-fgs-bar-days]'), barDaysWrap: $(root, '[data-fgs-bar-days-wrap]'), barQtyWrap: $(root, '[data-fgs-bar-qty-wrap]'), barQty: $(root, '[data-fgs-bar-qty]'),
      status: $(root, '[data-fgs-status]')
    };
    var CHECK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';

    function dayWord(n) { return lang() === 'id' ? n + ' hari' : (n === 1 ? '1 day' : n + ' days'); }

    function planRow(p) {
      var v = variantFor(p, state.days);
      var sel = p.key === state.key;
      var hasWas = v.compare_at_price && v.compare_at_price > v.price;
      return '<button type="button" class="fgs-plan" data-key="' + esc(p.key) + '" aria-pressed="' + sel + '">' +
        '<span class="fgs-plan__radio">' + CHECK + '</span>' +
        '<span class="fgs-plan__main"><span class="fgs-plan__label">' + esc(p.label) +
        (popular && p.key === popular.key ? '<span class="fgs-plan__badge">' + L('POPULAR') + '</span>' : '') + '</span>' +
        (p.kind === 'daily' && state.days ? '<span class="fgs-plan__per">' + esc(perDay(v.price, state.days)) + '</span>' : '') + '</span>' +
        '<span class="fgs-plan__prices"><span class="fgs-plan__price">' + esc(money(v.price)) + '</span>' +
        (hasWas ? '<span class="fgs-plan__was">' + esc(money(v.compare_at_price)) + '</span>' : '') + '</span></button>';
    }

    function render() {
      // Trip length tiles
      if (structured && dayList.length) {
        els.days.innerHTML = dayList.map(function (d) {
          return '<button type="button" class="fgs-day" data-days="' + d + '" aria-pressed="' + (d === state.days) + '" aria-label="' + dayWord(d) + '"><b>' + d + '</b><span>' + (lang() === 'id' ? 'hari' : d === 1 ? 'day' : 'days') + '</span></button>';
        }).join('');
      } else {
        els.days.hidden = true; els.daysHeading.hidden = true;
      }

      // Plans available for this trip length
      var avail = plans.filter(function (p) { return variantFor(p, state.days); });
      if (!avail.some(function (p) { return p.key === state.key; })) {
        var fallback = (popular && avail.indexOf(popular) >= 0 && popular) || avail.filter(function (p) { return p.kind === 'daily' && !p.unlimited; })[0] || avail[0];
        state.key = fallback ? fallback.key : '';
      }
      var first = avail.filter(function (p) { return firstKeys.indexOf(p.key) >= 0; });
      var rest = avail.filter(function (p) { return firstKeys.indexOf(p.key) < 0; });
      if (!first.length) { first = rest.slice(0, 6); rest = rest.slice(6); }
      if (rest.some(function (p) { return p.key === state.key; })) state.more = true;

      // Daily and total plans as two groups (side by side on desktop, stacked on mobile).
      function fill(el, list) {
        var dl = list.filter(function (p) { return p.kind === 'daily'; }), tl = list.filter(function (p) { return p.kind === 'total'; });
        var split = dl.length > 0 && tl.length > 0;
        el.classList.toggle('is-split', split);
        el.innerHTML = split ? '<div class="fgs-plan-col">' + dl.map(planRow).join('') + '</div><div class="fgs-plan-col">' + tl.map(planRow).join('') + '</div>' : list.map(planRow).join('');
      }
      if (first.length) fill(els.plans, first);
      else els.plans.innerHTML = '<p class="fgs-plans__empty">' + L('No plans are available for this trip length. Please pick another one.') + '</p>';
      fill(els.more, rest);
      els.more.hidden = !(rest.length && state.more);
      els.moreToggle.hidden = !rest.length;
      els.moreToggle.setAttribute('aria-expanded', String(!!state.more));
      els.moreLabel.textContent = L(state.more ? 'See Fewer Plans' : 'See More Plans');
      els.diff.hidden = !both;

      // Order card + sticky bar
      var plan = byKey[state.key];
      var v = plan ? variantFor(plan, state.days) : null;
      var buttons = $$(root, '[data-fgs-buy], [data-fgs-add]');
      buttons.forEach(function (b) { b.disabled = !v; });
      if (!v) { els.total.textContent = ''; els.barPrice.textContent = ''; return; }
      var q = state.qty;
      var validity = daysOf(v);
      els.detail.textContent = !structured ? '' : plan.label + ' • ' + dayWord(plan.kind === 'daily' ? state.days : validity);
      els.qtyN.textContent = q;
      $(root, '[data-fgs-qty="-1"]').disabled = q <= 1;
      $(root, '[data-fgs-qty="1"]').disabled = q >= 10;
      var hasWas = v.compare_at_price && v.compare_at_price > v.price;
      els.save.hidden = !hasWas;
      if (hasWas) {
        els.saveAmt.textContent = L('Save') + ' ' + money((v.compare_at_price - v.price) * q);
        els.was.textContent = money(v.compare_at_price * q);
      }
      // Buy Now: add the currency code once (never when the price text already contains it, e.g. "100.40 HKD")
      var totalText = money(v.price * q);
      els.total.textContent = currency === 'IDR' || totalText.indexOf(currency) >= 0 ? totalText : totalText + ' ' + currency;
      els.barPrice.textContent = money(v.price * q);
      els.barPlan.textContent = structured ? plan.short : plan.label;
      // Short form for the sticky bar: 7D (English and Indonesian)
      var barD = plan.kind === 'daily' ? state.days : (state.days || validity);
      els.barDays.textContent = structured && barD ? barD + 'D' : '';
      els.barDaysWrap.hidden = !structured || !barD;
      var unit = L(D.format === 'sim' ? (q > 1 ? 'SIM Cards' : 'SIM Card') : (q > 1 ? 'eSIMs' : 'eSIM'));
      els.barQty.textContent = q === 1 ? '1pc' : q + 'pcs';
      els.barQtyWrap.hidden = false;
      els.bar.classList.toggle('is-multi', q > 1);
      state.variant = v;
    }

    /* ---------- Events ---------- */
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button, a');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-days')) { state.days = parseInt(t.getAttribute('data-days'), 10); render(); return; }
      if (t.classList.contains('fgs-plan')) { state.key = t.getAttribute('data-key'); render(); return; }
      if (t.hasAttribute('data-fgs-more-toggle')) { state.more = !state.more; render(); return; }
      if (t.hasAttribute('data-fgs-qty')) { state.qty = Math.min(10, Math.max(1, state.qty + parseInt(t.getAttribute('data-fgs-qty'), 10))); render(); return; }
      if (t.hasAttribute('data-fgs-diff-toggle')) {
        var body = $(root, '[data-fgs-diff-body]'); body.hidden = !body.hidden; t.setAttribute('aria-expanded', String(!body.hidden)); return;
      }
      if (t.hasAttribute('data-fgs-buy')) { if (state.variant) location.href = (D.rootUrl || '/').replace(/\/?$/, '/') + 'cart/' + state.variant.id + ':' + state.qty; return; }
      if (t.hasAttribute('data-fgs-add')) { addToCart(t); return; }
    });

    function showStatus(text, isError) {
      els.status.textContent = text; els.status.hidden = false; els.status.classList.toggle('is-error', !!isError);
      clearTimeout(showStatus.t); showStatus.t = setTimeout(function () { els.status.hidden = true; }, 4000);
    }
    function addToCart(btn) {
      if (!state.variant) return;
      btn.disabled = true;
      var base = (D.rootUrl || '/').replace(/\/?$/, '/');
      fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: state.variant.id, quantity: state.qty }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: cart.item_count, cart: cart } }));
          showStatus(L('Added to cart.'));
        })
        .catch(function () { showStatus(L('This plan could not be added to the cart. Please try again.'), true); })
        .then(function () { btn.disabled = false; });
    }

    /* ---------- Countries ---------- */
    var groups = [];
    var gi = {};
    (D.countries || []).forEach(function (entry) {
      var parts = String(entry).split(' - ');
      var name = (parts[0] || '').trim();
      if (!name) return;
      if (!gi[name]) { gi[name] = { name: name, label: countryLabel(name), ops: [], code: (D.countryMap || {})[name.toLowerCase()] || '' }; groups.push(gi[name]); }
      var op = parts.slice(1).join(' - ').trim();
      if (op && gi[name].ops.indexOf(op) < 0) gi[name].ops.push(op);
    });
    // Operators: single-country products use the Network Operator field; multi-country products use
    // "Country - Operator" from the list, falling back to the Network Operator field; nothing if both are empty.
    var netOp = String(D.networkOperator || '').trim();
    if (groups.length === 1 && netOp) groups[0].ops = [netOp];
    else if (netOp) groups.forEach(function (g) { if (!g.ops.length) g.ops = [netOp]; });
    function flag(g) { return g.code ? String(D.flagUrl).replace('flag-de.svg', 'flag-' + g.code + '.svg') : D.placeholderFlag; }
    var featured = String(D.featuredCountries || '').split(',').map(function (s) { return gi[s.trim()]; }).filter(Boolean);
    if (!featured.length) featured = groups.slice(0, 3);
    var pf = $(root, '[data-fgs-proof-flags]');
    if (pf) pf.innerHTML = featured.slice(0, 3).map(function (g, i) { return '<img src="' + esc(flag(g)) + '" alt="" width="18" height="18" style="z-index:' + (3 - i) + '">'; }).join('');

    // Indonesian names are sorted A-Z in the countries pop-up; the English names still work in search.
    var sheetGroups = lang() === 'id' ? groups.slice().sort(function (a, b) { return a.label.localeCompare(b.label, 'id'); }) : groups;
    var listEl = $(root, '[data-fgs-country-list]');
    var qEl = $(root, '[data-fgs-country-q]');
    function renderCountries() {
      if (!listEl) return;
      var q = norm(qEl ? qEl.value : '');
      var rows = sheetGroups.filter(function (g) {
        if (!q) return true;
        var names = [g.name, g.label].concat(ALIASES[norm(g.name)] || []);
        return names.some(function (n) { return norm(n).indexOf(q) >= 0; });
      });
      listEl.innerHTML = rows.length ? rows.map(function (g) {
        return '<li class="fgs-country"><img src="' + esc(flag(g)) + '" alt="" width="32" height="32" loading="lazy"><div><div class="fgs-country__name">' + esc(g.label) + '</div>' +
          (g.ops.length ? '<div class="fgs-country__op">' + esc(g.ops.join(', ')) + '</div>' : '') + '</div></li>';
      }).join('') : '<li class="fgs-country--empty">' + L('No countries match') + ' “' + esc(qEl.value.trim()) + '”</li>';
    }
    if (qEl) qEl.addEventListener('input', renderCountries);

    // Shared with other sections (Where it works) and the global pop-up controller.
    FGS.countries = { groups: groups, flag: flag };
    FGS.sheetHooks.countries = function () { if (qEl) qEl.value = ''; renderCountries(); };
    document.dispatchEvent(new CustomEvent('fgs:countries'));

    document.body.classList.add('fgs-has-bar');
    render();
    initRail(root);
  }

  /* ---------- Desktop: the order card stays in view on the right, from the rating row down to the last
     product26vC section of the left column (Explore more and other theme sections are not covered). ---------- */
  function initRail(root) {
    var band = $(root, '.fgs-order-band'), col = $(root, '.fgs-col'), proof = $(root, '.fgs-proof');
    if (!band || !col) return;
    var mq = window.matchMedia('(min-width: 1024px)');
    function sectionOf(el) { return el.closest('.shopify-section') || el.parentElement; }
    function update() {
      if (!mq.matches) { band.style.removeProperty('--fgs-rail-top'); band.style.removeProperty('--fgs-rail-h'); return; }
      var top = proof ? proof.offsetTop : 0;
      var end = col;
      var sec = sectionOf(root);
      while (sec && (sec = sec.nextElementSibling)) {
        var c = sec.querySelector('.fgs-pdp--sub:not(.fgs-pdp--wide):not(.fgs-sheet) > .fgs-col');
        if (!c) break;
        end = c;
      }
      var colTop = col.getBoundingClientRect().top;
      var h = end.getBoundingClientRect().bottom - colTop - top;
      band.style.setProperty('--fgs-rail-top', top + 'px');
      band.style.setProperty('--fgs-rail-h', Math.max(h, band.firstElementChild ? band.firstElementChild.offsetHeight : 0) + 'px');
    }
    update();
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    if (mq.addEventListener) mq.addEventListener('change', update);
    if ('ResizeObserver' in window) new ResizeObserver(function () { update(); }).observe(document.body);
  }


  /* ================= Shared: pop-ups, data guide, small components ================= */
  var FGS = window.FGS = window.FGS || { sheetHooks: {} };
  FGS.sheetHooks = FGS.sheetHooks || {};
  FGS.esc = esc;

  var openEl = null, opener = null;
  function openSheet(name, from) {
    var sheet = document.querySelector('[data-fgs-sheet="' + name + '"]');
    if (!sheet) return;
    if (FGS.sheetHooks[name]) FGS.sheetHooks[name]();
    sheet.hidden = false; openEl = sheet; opener = from || null;
    document.documentElement.classList.add('fgs-lock');
    var close = $(sheet, '.fgs-sheet__close'); if (close) close.focus({ preventScroll: true });
  }
  function closeSheet() {
    if (!openEl) return;
    var panel = $(openEl, '.fgs-sheet__panel'); if (panel) panel.style.transform = '';
    openEl.hidden = true; openEl = null;
    document.documentElement.classList.remove('fgs-lock');
    if (opener) opener.focus({ preventScroll: true });
  }
  FGS.openSheet = openSheet; FGS.closeSheet = closeSheet;

  var level = 2;
  function setLevel(lv) {
    if (!GUIDE[lv]) return;
    level = lv;
    var info = GUIDE[lv], frac = lv / 3;
    $$(document, '[data-fgs-gauge]').forEach(function (g) {
      g.setAttribute('data-level', lv);
      $(g, '.fgs-gauge__fill').style.strokeDashoffset = (282.74 * (1 - frac)).toFixed(2);
      $(g, '.fgs-gauge__dot').style.transform = 'rotate(' + (frac * 180) + 'deg)';
      $(g, '[data-fgs-gauge-name]').textContent = L(info.name);
      $(g, '[data-fgs-gauge-amt]').textContent = L(info.amt);
      $(g, '[data-fgs-gauge-desc]').textContent = L(info.desc);
      $$(g, '[data-fgs-level]').forEach(function (b) { b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-fgs-level'), 10) === lv)); });
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-fgs-open], [data-fgs-close], [data-fgs-level], [data-fgs-toggle]');
    if (!t) return;
    if (t.hasAttribute('data-fgs-open')) { e.preventDefault(); openSheet(t.getAttribute('data-fgs-open'), t); return; }
    if (t.hasAttribute('data-fgs-close')) { closeSheet(); return; }
    if (t.hasAttribute('data-fgs-level')) { setLevel(parseInt(t.getAttribute('data-fgs-level'), 10)); return; }
    if (t.hasAttribute('data-fgs-toggle')) {
      // Generic show/hide: data-fgs-toggle="id-of-target"; the button's aria-expanded tracks it.
      var target = document.getElementById(t.getAttribute('data-fgs-toggle'));
      if (!target) return;
      target.hidden = !target.hidden;
      t.setAttribute('aria-expanded', String(!target.hidden));
      var label = t.querySelector('[data-label-open]');
      if (label) label.textContent = target.hidden ? label.getAttribute('data-label-closed') : label.getAttribute('data-label-open');
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openEl) closeSheet(); });
  function initDrag(head) {
    if (head.__fgsDrag) return; head.__fgsDrag = true;
    var y0 = null, dy = 0, panel = head.closest('.fgs-sheet__panel');
    head.addEventListener('pointerdown', function (e) { if (e.target.closest('button') || window.matchMedia('(min-width: 1024px)').matches) return; y0 = e.clientY; dy = 0; panel.classList.add('is-dragging'); if (head.setPointerCapture) head.setPointerCapture(e.pointerId); });
    head.addEventListener('pointermove', function (e) { if (y0 === null) return; dy = Math.max(0, e.clientY - y0); panel.style.transform = 'translateY(' + dy + 'px)'; });
    function end() { if (y0 === null) return; y0 = null; panel.classList.remove('is-dragging'); if (dy > 90) closeSheet(); else panel.style.transform = ''; }
    head.addEventListener('pointerup', end); head.addEventListener('pointercancel', end);
  }

  /* ---------- How it works: plays once when it scrolls into view ---------- */
  function initSteps(el) {
    if (el.__fgs) return; el.__fgs = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) { el.classList.add('is-playing'); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (x) { return x.isIntersecting; })) { el.classList.add('is-playing'); io.disconnect(); }
    }, { threshold: 0.6 });
    io.observe(el);
  }

  /* ---------- Where it works: top countries list ---------- */
  function initCoverage(el) {
    var list = $(el, '[data-fgs-coverage-list]');
    if (!list || !FGS.countries) return;
    if (el.__fgs) return; el.__fgs = true;
    var C = FGS.countries;
    var by = {}; C.groups.forEach(function (g) { by[g.name.toLowerCase()] = g; });
    var limit = parseInt(el.getAttribute('data-limit'), 10) || 5;
    var pick = String(el.getAttribute('data-featured') || '').split(',').map(function (s) { return by[s.trim().toLowerCase()]; }).filter(Boolean);
    C.groups.forEach(function (g) { if (pick.length < limit && pick.indexOf(g) < 0) pick.push(g); });
    pick = pick.slice(0, limit);
    list.innerHTML = pick.map(function (g) {
      return '<li class="fgs-country"><img src="' + esc(C.flag(g)) + '" alt="" width="32" height="32" loading="lazy"><div><div class="fgs-country__name">' + esc(g.label) + '</div>' +
        (g.ops.length ? '<div class="fgs-country__op">' + esc(g.ops.join(', ')) + '</div>' : '') + '</div></li>';
    }).join('');
    var more = $(el, '[data-fgs-coverage-more]');
    if (more) {
      more.hidden = C.groups.length <= pick.length;
      var n = $(more, '[data-fgs-coverage-count]'); if (n) n.textContent = C.groups.length;
    }
    el.hidden = !C.groups.length;
  }

  /* ---------- Phone check ---------- */
  function initPhone(el) {
    if (el.__fgs) return; el.__fgs = true;
    var cfg = {};
    try { cfg = JSON.parse($(el, '[data-fgs-phone-json]').textContent); } catch (e) { return; }
    var onSim = cfg.format === 'sim';
    var lines = function (s) { return String(s || '').split(/\r?\n/).map(function (x) { return x.trim(); }).filter(Boolean); };
    var ok = lines(cfg.supported), no = lines(cfg.unsupported);
    var input = $(el, '[data-fgs-phone-q]'), results = $(el, '[data-fgs-phone-results]');
    var show = function (name, on) { $$(el, '[data-show="' + name + '"]').forEach(function (n) { n.hidden = !on; }); };
    var state = { q: '', eidOpen: false, eid: '' };
    function render() {
      var q = state.q.trim().toLowerCase(), words = q.split(/\s+/).filter(Boolean);
      var hit = function (m) { var t = m.toLowerCase().split(/[\s()]+/).filter(Boolean); return words.every(function (w) { return t.some(function (x) { return x.indexOf(w) === 0; }); }); };
      var rows = q.length >= 2 ? ok.filter(hit).map(function (m) { return { name: m, ok: true }; }).concat(no.filter(hit).map(function (m) { return { name: m, ok: false }; })) : [];
      rows.sort(function (a, b) { return (b.ok - a.ok) || a.name.localeCompare(b.name, 'en', { numeric: true, sensitivity: 'base' }); });
      rows = rows.slice(0, 5);
      results.innerHTML = rows.map(function (r) {
        return '<div class="fgs-phone__row' + (r.ok ? ' is-ok' : '') + '"><span class="fgs-phone__model">' + esc(r.name) + '</span>' +
          (r.ok ? '<span class="fgs-phone__yes">' + TICK + L('Supports eSIM') + '</span>' : '<span class="fgs-phone__no">' + L('No eSIM support') + '</span>') + '</div>';
      }).join('');
      results.hidden = !rows.length;
      var anyOk = rows.some(function (r) { return r.ok; });
      var allNo = rows.length > 0 && !anyOk;
      var noMatch = q.length >= 3 && !rows.length;
      show('caution', anyOk);
      show('ok-sim', onSim && anyOk);
      show('none-esim', !onSim && allNo);
      show('none-sim', onSim && allNo);
      show('eid-link', !state.eidOpen && !noMatch && !allNo && !anyOk);
      var eidVisible = state.eidOpen || noMatch;
      show('eid', eidVisible);
      show('eid-close', state.eidOpen && !noMatch);
      show('eid-notfound', noMatch);
      show('eid-yes', state.eid === 'yes');
      show('eid-yes-sim', onSim && state.eid === 'yes');
      show('eid-no-esim', !onSim && state.eid === 'no');
      show('eid-no-sim', onSim && state.eid === 'no');
      show('sim-shortcut', !onSim && !allNo && state.eid !== 'no' && !anyOk);
      $$(el, '[data-eid]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-eid') === state.eid)); });
    }
    input.addEventListener('input', function () { state.q = input.value; state.eidOpen = false; state.eid = ''; render(); });
    el.addEventListener('click', function (e) {
      var t = e.target.closest('[data-eid], [data-fgs-eid-open], [data-fgs-eid-close]');
      if (!t) return;
      if (t.hasAttribute('data-fgs-eid-open')) state.eidOpen = true;
      if (t.hasAttribute('data-fgs-eid-close')) { state.eidOpen = false; state.eid = ''; }
      if (t.hasAttribute('data-eid')) state.eid = t.getAttribute('data-eid');
      render();
    });
    // Typing placeholder: iPhone 15 -> Samsung S24 -> Xiaomi 14
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var words = lines(cfg.placeholders).length ? lines(cfg.placeholders) : ['iPhone 15', 'Samsung S24', 'Xiaomi 14'];
    if (reduce) input.placeholder = L('e.g.') + ' ' + words[0];
    else {
      var w = 0, i = 0, del = false;
      (function tick() {
        var word = words[w];
        if (!del) { i++; input.placeholder = word.slice(0, i); if (i === word.length) { del = true; return setTimeout(tick, 1400); } return setTimeout(tick, 90); }
        i--; input.placeholder = word.slice(0, i); if (i === 0) { del = false; w = (w + 1) % words.length; return setTimeout(tick, 350); } setTimeout(tick, 40);
      })();
    }
    render();
  }
  var TICK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';

  /* ---------- FAQ accordion ---------- */
  function initFaq(el) {
    if (el.__fgs) return; el.__fgs = true;
    el.addEventListener('click', function (e) {
      var b = e.target.closest('.fgs-faq__q'); if (!b) return;
      var open = b.getAttribute('aria-expanded') === 'true';
      $$(el, '.fgs-faq__q').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = true; });
      if (!open) { b.setAttribute('aria-expanded', 'true'); var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = false; }
    });
  }

  /* ---------- Day-count pop-up: midnight in the visitor's own time (from their device) ---------- */
  function initLocalTime(el) {
    var off = parseFloat(el.getAttribute('data-offset'));
    if (isNaN(off)) return;
    var mine = -new Date().getTimezoneOffset() / 60;
    if (mine === off) { el.hidden = true; return; }
    var h = ((24 - off + mine) % 24 + 24) % 24, hh = Math.floor(h), mm = Math.round((h - hh) * 60);
    el.textContent = 'Midnight ' + el.getAttribute('data-zone') + ' is ' + (hh < 10 ? '0' : '') + hh + ':' + (mm < 10 ? '0' : '') + mm + ' your time.';
    el.hidden = false;
  }

  function boot() {
    $$(document, '[data-fgs-localtime]').forEach(initLocalTime);
    Array.prototype.forEach.call(document.querySelectorAll('[data-fgs-pdp]'), init);
    $$(document, '[data-fgs-drag]').forEach(initDrag);
    $$(document, '[data-fgs-steps]').forEach(initSteps);
    $$(document, '[data-fgs-coverage]').forEach(initCoverage);
    $$(document, '[data-fgs-phone]').forEach(initPhone);
    $$(document, '[data-fgs-faq]').forEach(initFaq);
  }
  document.addEventListener('fgs:countries', function () { $$(document, '[data-fgs-coverage]').forEach(initCoverage); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
